import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';

/**
 * It's unclear if this guard is needed as the Amplify AuthenticatorService
 * in app.component seems to handle it.
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(private router: Router, private authService: AuthService) {}
  public canActivate(): Observable<boolean> {
    return this.authService.currentSession$().pipe(
      catchError(() => {
        this.router.navigate(['/login']);
        return of(false);
      }),
      switchMap(s => {
        return of(true);
      })
    );
  }
}
